export function checkpointHasBeenFired(courseId: string, checkpoint: 70 | 100): boolean {
  const key = `checkpoint_fired_${courseId}_${checkpoint}`;
  return localStorage.getItem(key) === 'true';
}

export function markCheckpointAsFired(courseId: string, checkpoint: 70 | 100): void {
  const key = `checkpoint_fired_${courseId}_${checkpoint}`;
  localStorage.setItem(key, 'true');
}

export function clearCheckpointFired(courseId: string, checkpoint: 70 | 100): void {
  const key = `checkpoint_fired_${courseId}_${checkpoint}`;
  localStorage.removeItem(key);
}

export function clearAllCheckpointsForCourse(courseId: string): void {
  clearCheckpointFired(courseId, 70);
  clearCheckpointFired(courseId, 100);
}

export function clearAllCheckpoints(): void {
  const keys = Object.keys(localStorage).filter(key => key.startsWith('checkpoint_fired_'));
  keys.forEach(key => localStorage.removeItem(key));
}

export function getAllFiredCheckpoints(): Array<{
  courseId: string;
  checkpoint: 70 | 100;
}> {
  const keys = Object.keys(localStorage).filter(key => key.startsWith('checkpoint_fired_'));

  return keys.map(key => {
    const parts = key.replace('checkpoint_fired_', '').split('_');
    const checkpoint = parseInt(parts[parts.length - 1]) as 70 | 100;
    const courseId = parts.slice(0, -1).join('_');

    return { courseId, checkpoint };
  });
}

let checkpointModalInProgress = false;

export function setCheckpointModalInProgress(value: boolean): void {
  checkpointModalInProgress = value;
}

export function isCheckpointModalInProgress(): boolean {
  return checkpointModalInProgress;
}

interface CheckpointQueueItem {
  courseId: string;
  checkpoint: 70 | 100;
  timestamp: number;
}

let checkpointQueue: CheckpointQueueItem[] = [];

export function addCheckpointToQueue(courseId: string, checkpoint: 70 | 100): void {
  const exists = checkpointQueue.some(item => item.courseId === courseId && item.checkpoint === checkpoint);

  if (!exists) {
    checkpointQueue.push({
      courseId,
      checkpoint,
      timestamp: Date.now(),
    });
  }
}

export function getCheckpointQueue(): CheckpointQueueItem[] {
  return [...checkpointQueue];
}

export function clearCheckpointQueue(): void {
  checkpointQueue = [];
}

export function removeCheckpointFromQueue(courseId: string, checkpoint: 70 | 100): void {
  checkpointQueue = checkpointQueue.filter(item => !(item.courseId === courseId && item.checkpoint === checkpoint));
}

export function detectCheckpointJump(prevProgress: number | null, currProgress: number): (70 | 100)[] {
  if (prevProgress === null) {
    return [];
  }

  const checkpoints: (70 | 100)[] = [];

  if (prevProgress < 70 && currProgress >= 100) {
    checkpoints.push(100); // Só o 100
  } else {
    // Senão, comportamento normal
    if (prevProgress < 70 && currProgress >= 70) checkpoints.push(70);
    if (prevProgress < 100 && currProgress >= 100) checkpoints.push(100);
  }

  return checkpoints;
}

export function printCheckpointsReport(): void {
  getAllFiredCheckpoints();
}

export function debugCourse(courseId: string): void {
  const checkpoint70Fired = checkpointHasBeenFired(courseId, 70);
  const checkpoint100Fired = checkpointHasBeenFired(courseId, 100);
}
